<template>
	<Pie
		v-if="chartData.datasets[0]?.data?.length"
		:id="chartId"
		ref="chart"
		class="max-h-screen"
		:options="chartOptions"
		:data="chartData"
	/>
</template>

<script>
import { Pie } from 'vue-chartjs'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
	name: 'PieChart',
	components: { Pie },
	props: ['data', 'chartOptions', 'chartId'],
	data() {
		return {
			chartData: this.data
		}
	},
	watch: {
		data: {
			handler() {
				this.chartData = this.data
				if (this.$refs?.chart?.chart) {
					this.$refs.chart.chart.data = this.data
					this.$refs.chart.chart.update('resize')
				}
			},
			deep: true
		}
	}
}
</script>
